import { render, staticRenderFns } from "./DefaultLayout.vue?vue&type=template&id=37803b48&"
import script from "./DefaultLayout.vue?vue&type=script&lang=js&"
export * from "./DefaultLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Data\\Projects\\Werk\\DPG\\DNX2-DPG\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37803b48')) {
      api.createRecord('37803b48', component.options)
    } else {
      api.reload('37803b48', component.options)
    }
    module.hot.accept("./DefaultLayout.vue?vue&type=template&id=37803b48&", function () {
      api.rerender('37803b48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Components/Layout/DefaultLayout.vue"
export default component.exports